export type FranchiseDeliveryMode = "self" | "center";

export const FRANCHISE_FINANCIALS = {
  annualRight: 1_500_000,
  marketingMonthly: 50_000,
  advisorMonthly: 50_000,
  monthlyFixed: 100_000,
  annualRightMonthlyAverage: 125_000,
  centerShareRate: 0.4,
} as const;

export const FRANCHISE_PROMOTION = {
  partnerLimit: 10,
  originalAnnualRight: 5_000_000,
  discountedAnnualRight: 1_500_000,
} as const;

export const FRANCHISE_SERVICE_SCOPE = [
  ["🇺🇸", "АНУ", "Аялал, сургалт, гэр бүл, солилцоо"],
  ["🇨🇦", "Канад", "Аялал, сургалт"],
  ["🇦🇺", "Австрали", "Аялал, сургалт"],
  ["🇮🇪", "Ирланд", "Англи хэл, сургалт"],
  ["🇨🇿", "Чех", "Хөдөлмөрийн гэрээ"],
  ["🇳🇿", "Шинэ Зеланд", "Сургалт"],
  ["🇪🇺", "Шенген", "Аялал"],
] as const;

export const FRANCHISE_EXPERIENCE = {
  peopleServed: "20,000+",
  statement: "20,000+ хүнд зөвлөгөө, үйлчилгээ үзүүлсэн",
} as const;

export function formatMnt(value: number) {
  return `${new Intl.NumberFormat("mn-MN").format(Math.max(0, Math.round(value)))} ₮`;
}

export function calculateFranchiseEstimate(input: {
  clientsPerMonth: number;
  serviceFeePerClient: number;
  deliveryMode: FranchiseDeliveryMode;
}) {
  const grossServiceRevenue = input.clientsPerMonth * input.serviceFeePerClient;
  const centerExecutionDeduction =
    input.deliveryMode === "center"
      ? grossServiceRevenue * FRANCHISE_FINANCIALS.centerShareRate
      : 0;
  const monthlyProgramCosts =
    FRANCHISE_FINANCIALS.monthlyFixed +
    FRANCHISE_FINANCIALS.annualRightMonthlyAverage;
  const remainingEstimate =
    grossServiceRevenue - centerExecutionDeduction - monthlyProgramCosts;

  return {
    grossServiceRevenue,
    centerExecutionDeduction,
    monthlyProgramCosts,
    remainingEstimate,
  };
}

export function buildFranchiseInquiryPayload(input: {
  name: string;
  phone: string;
  location: string;
  question?: string;
}) {
  const name = input.name.trim();
  const phone = input.phone.trim();
  const location = input.location.trim();
  const question = input.question?.trim();

  return {
    name,
    phone,
    country: `Франчайз · ${location}`,
    message: [
      "Франчайзын хамтрагч болох хүсэлт",
      `Хот / улс: ${location}`,
      question ? `Асуулт: ${question}` : "",
    ].filter(Boolean).join("\n"),
  };
}
